import TopNavBar from '../../components/reusables/topNavBar';
import ReservationsTable from './reservationsTable';

function ReservationsParent() {
    return (
        <div className='h-full flex flex-col'>
            <TopNavBar
                title="Reservas"
                subtitle=""
            />
            <div className='flex-1 overflow-hidden font-poppins'>
                <ReservationsTable mode="parent" />
            </div>
        </div>
    );
}

export default ReservationsParent;
